export default "__VITE_ASSET__4L8lqMiE__"